document.addEventListener('DOMContentLoaded', () => {
  // File JS predisposto per eventuali future interazioni (es. pulsanti di accettazione rapida o ancore interne fluide)
});